import { render } from "./NavigationFieldItem.vue?vue&type=template&id=49fb1f32&scoped=true"
import script from "./NavigationFieldItem.vue?vue&type=script&lang=js"
export * from "./NavigationFieldItem.vue?vue&type=script&lang=js"

import "./NavigationFieldItem.vue?vue&type=style&index=0&id=49fb1f32&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fb1f32"]])

export default __exports__